import React from 'react';
import PropTypes from 'prop-types';
import { Popover, List, ListItem, Typography } from '@material-ui/core';
import guid from './../../../../utils/guid';
import t from "../../../../languages/pl";

const KeywordsPopover = props => {
    const { keywords, anchorEl, onClose } = props;
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const printContent = (data) => {
        if(!Array.isArray(data) || data.length === 0)
            return (
                <ListItem>
                    <Typography variant="body1">{t.noKeywords}</Typography>
                </ListItem>
            );
        return data.map(item => {
            return (
                <ListItem
                    key={guid()}
                >
                    <Typography variant="body1">
                        {item}
                    </Typography>
                </ListItem>
            );
        });
    };

    return (
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'center',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
        >
            <List>
                {printContent(keywords)}
            </List>
        </Popover>
    );
};

KeywordsPopover.propTypes = {
    classes: PropTypes.object,
    keywords: PropTypes.array,
    anchorEl: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func
};

export default (KeywordsPopover);
